"use client";

import { ShieldAlert } from "lucide-react";

import { AthenaCoverageEvidence } from "@/src/components/tasks/approval-types/athena-coverage-evidence";
import { ReferralMatchEvidence } from "@/src/components/tasks/approval-types/referral-match-evidence";
import { ValerieCard } from "@/src/components/valerie-card";
import { ApprovalType, type TaskApproval } from "@/src/models/task-approval";

function EvidenceContent({ approval }: { approval: TaskApproval }) {
  switch (approval.approvalType) {
    case ApprovalType.REFERRAL_MATCH:
      return <ReferralMatchEvidence metadata={approval.metadata} />;
    case ApprovalType.ATHENA_COVERAGE:
      if (!approval.metadata) {
        return <p className="text-sm text-destructive">Coverage confirmation details are unavailable.</p>;
      }

      return (
        <div className="space-y-3 text-sm">
          <p>{approval.metadata.instruction}</p>
          <AthenaCoverageEvidence metadata={approval.metadata} />
        </div>
      );
    case ApprovalType.TPR_RECEIVING_ASSIGNMENT:
      if (!approval.metadata) {
        return <p className="text-sm text-destructive">Receiving assignment details are unavailable.</p>;
      }

      return (
        <div className="space-y-3 text-sm">
          <p>{approval.metadata.instruction}</p>
          <p>
            <strong>Provider:</strong> {approval.metadata.providerName ?? "N/A"}
          </p>
          <p>
            <strong>Department:</strong> {approval.metadata.targetDepartmentId ?? "N/A"}
          </p>
        </div>
      );
    case ApprovalType.TPR_REFERRAL_OPS:
      if (!approval.metadata) {
        return <p className="text-sm text-destructive">Referral operations details are unavailable.</p>;
      }

      return <p className="text-sm">{approval.metadata.instruction}</p>;
    case ApprovalType.PATIENT_ELIGIBILITY:
      if (!approval.metadata) {
        return <p className="text-sm text-destructive">Patient eligibility details are unavailable.</p>;
      }

      return <p className="text-sm">{approval.metadata.instruction}</p>;
    default: {
      const _exhaustive: never = approval;

      return _exhaustive;
    }
  }
}

export function ApprovalEvidenceCard({ approval }: { approval: TaskApproval }) {
  return (
    <ValerieCard className="border-warn/20 bg-warn/5" icon={<ShieldAlert />} title="Action Pending Review">
      <EvidenceContent approval={approval} />
    </ValerieCard>
  );
}
